// Language translations for English and Spanish
export const translations = {
  en: {
    // Header
    nav: {
      services: "Services",
      howItWorks: "How It Works",
      areas: "Service Areas",
      testimonials: "Testimonials",
      bookNow: "Book Now",
      login: "Login",
      account: "My Account"
    },
    // Hero Section
    hero: {
      title: "Professional Wash & Fold Service",
      subtitle: "Free Pickup & Delivery",
      description: "Let us handle your laundry while you focus on what matters most. Quality cleaning with convenient doorstep service.",
      bookPickup: "Book Free Pickup",
      learnMore: "Learn More"
    },
    // Services Section
    services: {
      title: "Our Services",
      subtitle: "Quality laundry care for all your needs",
      washFold: {
        title: "Wash & Fold",
        description: "Professional washing and folding service for your everyday clothes"
      },
      freePickup: {
        title: "Free Pickup",
        description: "We come to you! Free pickup service at your doorstep"
      },
      freeDelivery: {
        title: "Free Delivery",
        description: "Clean clothes delivered back to your door at no extra cost"
      },
      sameDayService: {
        title: "Same-Day Service*",
        description: "Same-day service available for qualifying orders picked up before 4 PM"
      }
    },
    // Booking Form
    booking: {
      title: "Schedule Your Pickup",
      subtitle: "Fast, easy, and convenient",
      name: "Full Name",
      phone: "Phone Number",
      email: "Email Address",
      address: "Pickup Address",
      city: "City",
      selectCity: "Select your city",
      pickupDate: "Pickup Date",
      pickupTime: "Preferred Time",
      selectTime: "Select time",
      notes: "Special Instructions",
      notesPlaceholder: "Any special requests or instructions...",
      paymentOption: "Payment Option",
      payNow: "Pay Now",
      payLater: "Pay at Pickup",
      termsText: "By scheduling this pickup, I confirm that I have read, understood, and agree to the",
      termsLink: "Wash & Fold Terms & Conditions",
      termsDisclaimer: "I acknowledge that Family Laundry LLC is not responsible for loss, damage, shrinkage, or normal wear and tear of items beyond the cost of the service provided.",
      termsWarning: "You must agree to the Terms & Conditions to proceed.",
      submitButton: "Schedule Pickup",
      proceedPayment: "Proceed to Payment",
      processing: "Processing..."
    },
    // Pricing
    pricing: {
      perPound: "Per Pound",
      perPoundPrice: "$1.50/lb",
      flatRate: "Flat Rate Packages",
      small: "Small Load",
      smallDesc: "Up to 10 lbs",
      medium: "Medium Load",
      mediumDesc: "Up to 20 lbs",
      large: "Large Load",
      largeDesc: "Up to 30 lbs",
      xlarge: "Extra Large",
      xlargeDesc: "Up to 50 lbs"
    },
    // Footer
    footer: {
      about: "About Us",
      aboutText: "Family Laundry LLC provides professional wash & fold services with free pickup and delivery.",
      quickLinks: "Quick Links",
      contact: "Contact Us",
      hours: "Hours: 9 AM - 4 PM",
      rights: "All rights reserved."
    },
    // Common
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      cancel: "Cancel",
      confirm: "Confirm",
      save: "Save",
      close: "Close",
      back: "Back"
    }
  },
  es: {
    // Header
    nav: {
      services: "Servicios",
      howItWorks: "Cómo Funciona",
      areas: "Áreas de Servicio",
      testimonials: "Testimonios",
      bookNow: "Reservar",
      login: "Iniciar Sesión",
      account: "Mi Cuenta"
    },
    // Hero Section
    hero: {
      title: "Servicio Profesional de Lavado y Doblado",
      subtitle: "Recogida y Entrega Gratis",
      description: "Déjanos encargarnos de tu ropa mientras te enfocas en lo que más importa. Limpieza de calidad con servicio conveniente a domicilio.",
      bookPickup: "Reservar Recogida Gratis",
      learnMore: "Más Información"
    },
    // Services Section
    services: {
      title: "Nuestros Servicios",
      subtitle: "Cuidado de lavandería de calidad para todas tus necesidades",
      washFold: {
        title: "Lavar y Doblar",
        description: "Servicio profesional de lavado y doblado para tu ropa de todos los días"
      },
      freePickup: {
        title: "Recogida Gratis",
        description: "¡Vamos a ti! Servicio de recogida gratis en tu puerta"
      },
      freeDelivery: {
        title: "Entrega Gratis",
        description: "Ropa limpia entregada a tu puerta sin costo adicional"
      },
      sameDayService: {
        title: "Servicio Mismo Día",
        description: "Recogida antes de las 4 PM para entrega el mismo día"
      }
    },
    // Booking Form
    booking: {
      title: "Programa Tu Recogida",
      subtitle: "Rápido, fácil y conveniente",
      name: "Nombre Completo",
      phone: "Número de Teléfono",
      email: "Correo Electrónico",
      address: "Dirección de Recogida",
      city: "Ciudad",
      selectCity: "Selecciona tu ciudad",
      pickupDate: "Fecha de Recogida",
      pickupTime: "Hora Preferida",
      selectTime: "Selecciona hora",
      notes: "Instrucciones Especiales",
      notesPlaceholder: "Cualquier solicitud o instrucción especial...",
      paymentOption: "Opción de Pago",
      payNow: "Pagar Ahora",
      payLater: "Pagar al Recoger",
      termsText: "Al programar esta recogida, confirmo que he leído, entendido y acepto los",
      termsLink: "Términos y Condiciones de Lavado y Doblado",
      termsDisclaimer: "Reconozco que Family Laundry LLC no es responsable por pérdida, daño, encogimiento o desgaste normal de artículos más allá del costo del servicio proporcionado.",
      termsWarning: "Debes aceptar los Términos y Condiciones para continuar.",
      submitButton: "Programar Recogida",
      proceedPayment: "Proceder al Pago",
      processing: "Procesando..."
    },
    // Pricing
    pricing: {
      perPound: "Por Libra",
      perPoundPrice: "$1.50/lb",
      flatRate: "Paquetes de Tarifa Fija",
      small: "Carga Pequeña",
      smallDesc: "Hasta 10 lbs",
      medium: "Carga Mediana",
      mediumDesc: "Hasta 20 lbs",
      large: "Carga Grande",
      largeDesc: "Hasta 30 lbs",
      xlarge: "Extra Grande",
      xlargeDesc: "Hasta 50 lbs"
    },
    // Footer
    footer: {
      about: "Sobre Nosotros",
      aboutText: "Family Laundry LLC ofrece servicios profesionales de lavado y doblado con recogida y entrega gratis.",
      quickLinks: "Enlaces Rápidos",
      contact: "Contáctenos",
      hours: "Horario: 9 AM - 4 PM",
      rights: "Todos los derechos reservados."
    },
    // Common
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      cancel: "Cancelar",
      confirm: "Confirmar",
      save: "Guardar",
      close: "Cerrar",
      back: "Volver"
    }
  }
};

export default translations;
